import React from "react";

import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import Typography from "@material-ui/core/Typography";

import styles from "./styles";
const useStyles = makeStyles(styles);

function IndexItem({ service, onSelect }) {
  const classes = useStyles();

  const handleSelect = () => onSelect(service);

  return (
    <ListItem
      button
      key={service.cdServico}
      onClick={handleSelect}
      className={classes.item}
    >
      <ListItemText
        primary={
          <Typography className={classes.itemText}>{service.nmServico}</Typography>
        }
      />
      <KeyboardArrowRight></KeyboardArrowRight>
    </ListItem>
  );
}

export default IndexItem;
